:host {
  display: block;
}

.landing-background {
  background-color: var(--clrs-landing-background);
}
